export default () => [
  {
    field: 'seq',
    width: 50,
    align: 'center',
    fixed: 'left',
    type: 'seq',
  },
  { width: 40, align: 'center', fixed: 'left', type: 'checkbox' },
  {
    field: 'col-opt',
    title: '操作',
    headerAlign: 'center',
    align: 'left',
    fixed: 'left',
    width: 80,
    slots: {
      default: 'opt',
    },
  },
  {
    field: 'waybillNo',
    title: '运单编号',
    headerAlign: 'center',
    align: 'center',
    width: 150,
    fixed: 'left',
    showHeaderOverflow: 'title',
    showOverflow: 'ellipsis',
    slots: {
      default: 'waybillNo',
    },
  },
  {
    field: 'wayBillStatusName',
    title: '运单状态',
    headerAlign: 'center',
    align: 'center',
    fixed: 'left',
    width: 80,
    showHeaderOverflow: 'title',
    showOverflow: 'ellipsis',
  },
  {
    field: 'carrierShortName',
    title: '承运商',
    headerAlign: 'center',
    align: 'left',
    width: 100,
    showHeaderOverflow: 'title',
    showOverflow: 'ellipsis',
  },
  {
    field: 'driverName',
    title: '司机姓名',
    headerAlign: 'center',
    align: 'left',
    width: 80,
    showHeaderOverflow: 'title',
    showOverflow: 'ellipsis',
  },
  {
    field: 'driverMobile',
    title: '司机手机号',
    headerAlign: 'center',
    align: 'center',
    width: 115,
    showHeaderOverflow: 'title',
    showOverflow: 'ellipsis',
  },
  {
    field: 'vehicleNo',
    title: '车牌号',
    headerAlign: 'center',
    align: 'center',
    width: 90,
    showHeaderOverflow: 'title',
    showOverflow: 'ellipsis',
  },
  {
    field: 'assistant',
    title: '跟车员',
    headerAlign: 'center',
    align: 'left',
    width: 80,
    showHeaderOverflow: 'title',
    showOverflow: 'ellipsis',
  },
  {
    field: 'assistantMobile',
    title: '跟车员手机',
    headerAlign: 'center',
    align: 'center',
    width: 115,
    showHeaderOverflow: 'title',
    showOverflow: 'ellipsis',
  },
  {
    field: 'transportModeName',
    title: '运输方式',
    headerAlign: 'center',
    align: 'center',
    width: 80,
    showHeaderOverflow: 'title',
    showOverflow: 'ellipsis',
  },

  {
    field: 'orderCount',
    title: '订单数',
    headerAlign: 'center',
    align: 'center',
    width: 70,
    showHeaderOverflow: 'title',
    showOverflow: 'ellipsis',
  },
  {
    field: 'totQty',
    title: '总件数',
    headerAlign: 'center',
    align: 'center',
    width: 70,
    showHeaderOverflow: 'title',
    showOverflow: 'ellipsis',
  },
  {
    field: 'totPayWeight',
    title: '总重量kg',
    headerAlign: 'center',
    align: 'center',
    width: 90,
    showHeaderOverflow: 'title',
    showOverflow: 'ellipsis',
  },
  {
    field: 'totPayVolume',
    title: '总体积m³',
    headerAlign: 'center',
    align: 'center',
    width: 90,
    showHeaderOverflow: 'title',
    showOverflow: 'ellipsis',
  },
]
